import { useEffect } from 'react';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';

import { useUpdateChangedClusters } from '../../../../hooks/useUpdateChangedClusters';

import { useGetClusterByActivePinId } from './useGetClusterByActivePinId';

/**
 * Этот хук отслеживает изменение "clusters" в контексте активного пина.
 * Если пин выбран (т.е. показан листинг по пину), и произошел перезапрос массива "clusters", что м.б.
 * при зуме карты или её сдвиге, то нужно выставить корректные св-ва для активного пина.
 */
export function useTrackClustersChanged(): void {
  const { data } = useGetClustersQuery();
  const activeCluster = useGetClusterByActivePinId();
  const updateChangedClusters = useUpdateChangedClusters();

  useEffect(() => {
    if (activeCluster) {
      activeCluster.properties ??= {};
      activeCluster.properties.active = 1;

      updateChangedClusters(activeCluster);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
}
